package one.healthium.data.user.utils

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.AuthResult
import dev.gitlive.firebase.auth.FirebaseAuth
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.functions.functions
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.data.user.dto.CredentialsDto
import one.healthium.domain.user.models.SignInOptions

suspend fun FirebaseAuth.signInWithOptions(options: SignInOptions): AuthResult =
    when (options) {
        is SignInOptions.Username -> signInWithEmailAndPassword(options.username, options.password)
        is SignInOptions.MagicLink -> signInWithCustomToken(exchangeMagicLinkToken(options.token))
        is SignInOptions.WebUser -> {
            val usernameSignInOptions = exchangeWebUserToken(options.token) ?: throw IllegalArgumentException("Invalid web user token")
            signInWithEmailAndPassword(usernameSignInOptions.username, usernameSignInOptions.password)
        }
    }

private suspend fun exchangeMagicLinkToken(token: String): String {
    return Firebase.functions.httpsCallable("exchangeMagicLink")
        .invoke(mapOf("token" to token))
        .data<ExchangeTokenResponse>().customToken
}

private suspend fun exchangeWebUserToken(token: String): SignInOptions.Username? {
    return Firebase.firestore
        .collection("webUsers")
        .document(token)
        .get()
        .takeIf { it.exists }
        ?.data(CredentialsDto.serializer())
        ?.let { dto ->
            SignInOptions.Username(
                dto.email,
                dto.password
            )
        }
}

@Serializable
private data class ExchangeTokenResponse(
    @SerialName("customToken") val customToken: String,
    @SerialName("email") val email: String,
)